export default "__VITE_ASSET__BcVfxSsE__"